import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

const ChapitreEditDialog = ({ chapitre, visible, onHide, onSave }) => {
  const [capacity, setCapacity] = useState("");
  const [isEnabled, setIsEnabled] = useState(true);
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!visible || !chapitre) {
      return;
    }

    setCapacity(chapitre.MaxPeople === null || chapitre.MaxPeople === undefined ? "" : String(chapitre.MaxPeople));
    setIsEnabled(Boolean(chapitre.IsEnabled));
    setError("");
  }, [visible, chapitre]);

  const parseCapacity = () => {
    if (capacity === "") {
      return null;
    }
    const value = Number(capacity);
    if (!Number.isFinite(value) || !Number.isInteger(value)) {
      return NaN;
    }
    return value;
  };

  const handleSave = async () => {
    if (!chapitre || isSaving) {
      return;
    }

    const parsedCapacity = parseCapacity();
    if (Number.isNaN(parsedCapacity)) {
      setError("Capacity must be a whole number.");
      return;
    }
    if (parsedCapacity !== null && parsedCapacity < 0) {
      setError("Capacity must be a nonnegative number.");
      return;
    }

    setIsSaving(true);
    setError("");
    try {
      await onSave({
        MaxPeople: parsedCapacity,
        IsEnabled: isEnabled ? 1 : 0
      });
      onHide();
    } catch (saveError) {
      setError(saveError?.message || "Update failed.");
    } finally {
      setIsSaving(false);
    }
  };

  const footer = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Cancel"
        onClick={onHide}
        className="p-button-text"
        disabled={isSaving}
        data-cy="chapitre-edit-cancel"
      />
      <Button
        label={isSaving ? "Saving..." : "Save"}
        onClick={handleSave}
        disabled={isSaving}
        data-cy="chapitre-edit-save"
      />
    </div>
  );

  return (
    <Dialog
      header={chapitre ? `Configure ${chapitre.Name}` : "Configure chapitre"}
      visible={visible}
      style={{ width: "28rem" }}
      onHide={onHide}
      footer={footer}
    >
      {chapitre ? (
        <div className="flex flex-column gap-3" data-cy="chapitre-edit-dialog">
          <div className="flex flex-column gap-2">
            <label htmlFor="chapitre-capacity" className="font-medium">Capacity</label>
            <InputText
              id="chapitre-capacity"
              type="number"
              min="0"
              step="1"
              value={capacity}
              onChange={(e) => setCapacity(e.target.value)}
              placeholder="Leave blank for no limit"
              data-cy="chapitre-capacity-input"
            />
          </div>
          <div className="flex align-items-center gap-2">
            <Checkbox
              inputId="chapitre-enabled"
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e.checked)}
              data-cy="chapitre-enabled-checkbox"
            />
            <label htmlFor="chapitre-enabled" className="font-medium">Enabled</label>
          </div>
          {error && <small className="p-error" data-cy="chapitre-capacity-error">{error}</small>}
        </div>
      ) : (
        <p>No chapitre selected.</p>
      )}
    </Dialog>
  );
};

export default ChapitreEditDialog;
